import { booleanAttribute, Component, input } from '@angular/core';

@Component({
  selector: 'app-helper-text',
  template: `
    @if (helperText()) {
      <small id="helperText" class="col-span-12  mt-1 text-sm text-text-500">
        {{ helperText() }}
      </small>
    }

    @if (showErrors() && errorMessage()) {
      <small
        id="errorMessage"
        class="flex items-center col-span-12 gap-1 mt-1 text-sm text-error-800"
      >
        <i class="!text-base material-symbols-outlined"> error </i>
        {{ errorMessage() }}
      </small>
    }
  `,
})
export class HelperTextComponent {
  helperText = input<string>();
  showErrors = input(false, { transform: booleanAttribute });
  errorMessage = input<string>();
}
